// TanStack Query client: 5 min stale, 30 min cache, no refetch on focus, retries (at most 2) only for network errors and 5xx other than 501.
import { QueryClient } from "@tanstack/react-query";

import { isApiProblem } from "@/api/problem";

export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) {
    return false;
  }
  if (isApiProblem(error)) {
    return error.isRetryable;
  }
  return error instanceof TypeError;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60_000,
        gcTime: 30 * 60_000,
        refetchOnWindowFocus: false,
        retry: shouldRetry,
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      },
      mutations: {
        retry: false,
      },
    },
  });
}
